export const STORE_LOCATION_SELECTED = 'store.location.selected';
export const STORE_TOWN_SELECTED = 'store.town.selected';
export const APPOINTMENT_BOOKED = 'appointment.booked';

export interface IStoreLocationSelectionData {
    storeId?: string;
}

export interface IStoreTownSelectionData {
    town?: string;
}

export interface IAppointmentBookedData {
    email: string;
    source: string;
}

export type ServiceAppointmentBookingEvents = {
    [STORE_LOCATION_SELECTED]: IStoreLocationSelectionData | void;
    [STORE_TOWN_SELECTED]: IStoreTownSelectionData | void;
    [APPOINTMENT_BOOKED]: IAppointmentBookedData;
};
